module.exports = __webpack_public_path__ + "static/media/7-8.e586a73a.mp3";